export const router = {
  HOME: "/",
  CONTACT: "/contact",
  FAQ: "/faq",
  AGREEMENT: "/agreement",
  JOURNEY: "/journey",
};
